import { render, staticRenderFns } from "./modal-motivo-assinatura.vue?vue&type=template&id=45e655a1"
import script from "./modal-motivo-assinatura.vue?vue&type=script&lang=js"
export * from "./modal-motivo-assinatura.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports